import React, { cloneElement } from 'react'
import T from 'prop-types'
import ReactDOM from 'react-dom'
import cx from 'classnames'

const modalRoot = document.getElementById('modal_root') || document.body

export default class MenuPortal extends React.Component {
  static propTypes = {
    children: T.node,
    menuOwnerId: T.string.isRequired,
    menuId: T.string.isRequired,
    onDetached: T.func.isRequired,
    onRendered: T.func.isRequired,
    alignSelf: T.func.isRequired
  }

  componentDidMount() {
    this.props.onRendered()
  }

  componentDidUpdate() {
    this.props.alignSelf()
  }

  componentWillUnmount() {
    this.props.onDetached()
  }

  render() {
    const {
      children,
      menuId,
      menuOwnerId
    } = this.props

    return children ? ReactDOM.createPortal(
      cloneElement(
        React.Children.only(children),
        {
          className: cx(
            'pw_popup_menu dropdown-menu',
            React.Children.only(children).props.className
          ),
          role: 'menu',
          id: menuId,
          'data-menuownerid': menuOwnerId
        }
      ),
      modalRoot
    ) : null
  }
}